import AdminManagement from '../pages/admin-management/index'
import AdminManagementHomePage from '../pages/admin-management/home'
import ProtectedRoute from './protected'
import SelectOptions from '../pages/admin-management/select-option'
import InvitationLinkPage from '../pages/admin-management/InvitationLinkPage'
import InviteSingleEmployee from '../pages/admin-management/InviteSingleEmployee'
import CreateSingleEmployee from '../pages/admin-management/CreateSingleEmployee'
import InviteBulkEmployee from '../pages/admin-management/InviteBulkEmployee'
import CreateBulkEmployee from '../pages/admin-management/CreateBulkEmployee'
import AddSalaryInfo from '../pages/admin-management/AddSalaryInfo'
import AddSingleEmployeePay from '../pages/admin-management/AddEmployeePay'
import AddCompleteSingleSalaryInfo from '../pages/admin-management/AddCompleteSingleSalaryInfo'
import AddBulkEmployeePay from '../pages/admin-management/AddBulkEmployeePay'
import ViewEmployeePage from '../pages/admin-management/ViewEmployeePage'
import AddEmployeeToGroup from '../pages/admin-management/AddEmployeeToGroup'

const AddingEmployeeRoute = [
  <ProtectedRoute
    exact
    path='/employees/onboarding/select-option'
    component={SelectOptions}
  />,
  <ProtectedRoute
    exact
    path='/employees/onboarding/add-single-employee/invite'
    component={InviteSingleEmployee}
  />,
  <ProtectedRoute
    exact
    path='/employees/onboarding/add-single-employee/create'
    component={CreateSingleEmployee}
  />,
  <ProtectedRoute
    exact
    path='/employees/onboarding/add-bulk-employee/invite'
    component={InviteBulkEmployee}
  />,
  <ProtectedRoute
    exact
    path='/employees/onboarding/add-single-employee/invitation-link'
    component={InvitationLinkPage}
  />,

  <ProtectedRoute
    exact
    path='/employees/onboarding/add-bulk-employee/create'
    component={CreateBulkEmployee}
  />,
  <ProtectedRoute
    exact
    path='/employees/onboarding/add-employee-to-group'
    component={AddEmployeeToGroup}
  />,
  // <ProtectedRoute
  //   exact
  //   path='/employees/onboarding/assign-onboarding-workflow'
  //   component={InitiateEmployeeOnboarding}
  // />,
  <ProtectedRoute
    exact
    path='/employees/onboarding/add-salary-information'
    component={AddSalaryInfo}
  />,

  <ProtectedRoute
    exact
    path='/employees/onboarding/complete-single-salary-information'
    component={AddCompleteSingleSalaryInfo}
  />,

  <ProtectedRoute
    exact
    path='/employees/onboarding/add-single-salary-information'
    component={AddSingleEmployeePay}
  />,

  <ProtectedRoute
    exact
    path='/employees/onboarding/add-bulk-salary-information'
    component={AddBulkEmployeePay}
  />,
]

export const AdminManagementRoutes = [
  <ProtectedRoute
    exact
    path='/admin-management'
    component={AdminManagementHomePage}
  />,
  <ProtectedRoute exact path='/employees' component={AdminManagement} />,
  <ProtectedRoute exact path='/salaries' component={AdminManagement} />,
  <ProtectedRoute
    exact
    path='/employees/view/:id'
    component={ViewEmployeePage}
  />,

  ...AddingEmployeeRoute,
]
